import * as React from 'react';
import Stream from './components/Stream';
import GapItemFragment from './fragments/GapItemFragment.gql';
import StreamPlaceholder from './components/StreamPlaceholder';
import LimitedStreamPlaceholder from './components/LimitedStreamPlaceholder';
import ChatStreamFragment from './fragments/ChatStreamFragment.gql';
import EntityStreamFragment from './fragments/EntityStreamFragment.gql';
import SequenceItemFragment from './fragments/SequenceItemFragment.gql';
import PhoneCallItemFragment from './fragments/PhoneCallItemFragment.gql';
import SystemMessageItemFragment from './fragments/SystemMessageItemFragment.gql';

export const CTX_CHAT_STREAM = 'CTX_CHAT_STREAM';
export const CTX_ANNOUNCEMENT_STREAM = 'CTX_ANNOUNCEMENT_STREAM';
// $FlowFixMe - 0.93.0 flow wonkiness.
export const StreamContext = React.createContext(CTX_ANNOUNCEMENT_STREAM);

export {
  Stream,
  GapItemFragment,
  StreamPlaceholder,
  LimitedStreamPlaceholder,
  ChatStreamFragment,
  EntityStreamFragment,
  SequenceItemFragment,
  PhoneCallItemFragment,
  SystemMessageItemFragment,
};
